import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Reloads joint-use data when the organization collection context changes.
 */
export const loadOnContextChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.feature.actions.changeContext
      .observe()
      .pipe(
        rxjs.map(action =>
          feature.actions.loadForCurrentEntity.request.from(action).create(),
        ),
      ),
)
